import React from "react";
import JeaCard from "@/components/jea/JeaCard";
import Skeleton from "@/components/jea/Skeleton";

const StatCard = ({ label, value, valueClass = "", Icon, loading = false, testid, extra }) => (
  <JeaCard className="relative" data-testid={testid}>
    <div className="flex items-start justify-between gap-3">
      <div className="jea-caption">{label}</div>
      {Icon && <Icon size={20} className="text-accent-pink shrink-0" strokeWidth={2} />}
    </div>
    <div className="mt-3">
      {loading ? (
        <Skeleton className="h-8 w-24" />
      ) : (
        <div className={`text-white font-bold text-[28px] leading-none ${valueClass}`} data-testid={`${testid}-value`}>
          {value}
        </div>
      )}
    </div>
    {extra && <div className="mt-2">{extra}</div>}
  </JeaCard>
);

export default StatCard;
